import {Card, CardBody, Spinner, Table, TableCaption, TableContainer, Tbody, Thead, Checkbox, Stack, Tr, Th } from '@chakra-ui/react'
import { ItemsCountedTableRow } from './ItemsCountedTable/ItemsCountedTableRow'
import Pagination from 'components/Pagination/Pagination'
import { useState, useContext } from 'react'
import { Captions } from 'components/Counting/Captions'
import { CountingTabsContext } from 'components/Counting/CountingTabs/CountingTabs'
import {useItemsCounted} from 'hooks/useItems/useItemsCounted'
import {ItemsCountedFilters} from './ItemsCountedFilters/ItemsCountedFilters'
import {HeaderSortable} from 'components/Inputs/HeaderSortable'

export const ItemsCounted = (props) => {
	const { countingId, refreshCounting } = props
	const {itemsCounted, getItemsCounted, toggleSortOrder, sortConfig, loading, filters}
		= useItemsCounted({counting_id: countingId})


	const [currentPage, setCurrentPage] = useState(1)
	const { counting } = useContext(CountingTabsContext)


    const handlePageChange = (selectedPage) => {
        getItemsCounted(selectedPage)
        setCurrentPage(selectedPage)
    }

    const refreshTable = () => {
        getItemsCounted({ page: currentPage })
        refreshCounting()
    }



	return (
		<Card>
			<CardBody>

			<TableContainer>
            <Table>
                <TableCaption placement={'top'}>
                    <Captions
                        total={itemsCounted.total}
                        totalAmount={itemsCounted.total_amount}
                        totalRows={itemsCounted.total_rows}
                        countingId={countingId}
                        counting={counting}
                        group_items={filters.group_items}
                    />
					<Stack direction='row' spacing={4}>
						<Checkbox onChange={(e) => getItemsCounted({group_items: e.target.checked})}>Grouped Items</Checkbox>
					</Stack>
                </TableCaption>
                <Thead>
                    {!filters.group_items && 
                        <ItemsCountedFilters countingId={countingId} handleFilterChange={(newFilters) => {
							getItemsCounted(newFilters)
						}} counting={counting}/>
                    }
                    <Tr>
                        <Th>UPC</Th>
                        <Th>MKT</Th>
                        <Th>
                            <HeaderSortable fieldName='amount' title='Amount' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} />
                        </Th>
                        <Th>Description</Th>
                        {!filters.group_items && <Th>Row</Th>}
                        {!filters.group_items && <Th>Category</Th>}
                        { counting.settings?.customRowNames && <Th>Custom Row Name</Th>}
                        
                        <Th>
                            <HeaderSortable fieldName='mkt_1_length' title='Length' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} />
                        </Th>
                        {!filters.group_items && <>
                            <Th>Time</Th>
                            <Th>Device</Th>
                            <Th>Name</Th>
                            <Th>Invalid</Th>
                            <Th>Manual</Th>
                        </>}
                    </Tr>
                </Thead>
            
                <Tbody>
                    { itemsCounted.data && ( 
                        itemsCounted.data.map(item => (
                            <ItemsCountedTableRow
                                key={item._id}
                                id={item._id}
                                upc={item.upc}
                                device={item.device_number}
                                row={item.row_name}
                                category={itemsCounted.rows[item.row_name]?.category_row?.name}
                                description={item.description}
                                customRowName={itemsCounted.rows[item.row_name]?.custom_row_name}
                                mkt={item.mkt_1}
                                amount={item.amount}
                                length={item?.mkt_1_length}
                                time={item.scanned_at ? item.scanned_at : item.created_at}
                                name={`${item?.user?.name} ${item?.user?.last_name}`}
                                lastName={`${item?.user?.last_name}`}
                                isFound={item.is_found}
                                isManual={item.is_manual}
                                refreshTable={refreshTable}
                                refreshCounting={refreshCounting}
                                counting={counting}
                                deletedAt={item.deleted_at}
                                group_items={filters.group_items}
                            />
                        )))}
                </Tbody>
            
            </Table> 
            {!loading  || <Spinner /> } <Pagination lastPage={itemsCounted.last_page ?? 1} getData={handlePageChange} />
        </TableContainer>
				{/* <ItemsCountedTable
					itemsCounted={itemsCounted}
					getItemsCounted={getItemsCounted}
					toggleSortOrder={toggleSortOrder}
					sortConfig={sortConfig}
					loading={loading}
					refreshCounting={refreshCounting}
					countingId={countingId}
					counting={counting}
				/> */}
			</CardBody>
		</Card>
	)
}